/**
 * Counter offer form validation
 */

import { errorMessages } from './errorMessages';
import type { ValidationResult } from './types';

type CounterOfferTerms = {
  counterAmount: string;
  counterRate: string;
  counterTermMonths: number;
};

export const validateCounterOfferTerms = (form: CounterOfferTerms): ValidationResult => {
  const errors: Partial<Record<keyof CounterOfferTerms, string[]>> = {};

  // Counter Amount validation - use existing poolAmount validation
  const amountError = errorMessages.poolAmount(form.counterAmount);
  if (amountError) errors.counterAmount = [amountError];

  // Counter Rate validation - use existing roiRate validation, then check range
  const rateError = errorMessages.roiRate(form.counterRate);
  if (rateError) {
    errors.counterRate = [rateError];
  }

  // Term validation - convert number to string for validation
  const termString = form.counterTermMonths.toString();
  const termError = errorMessages.term(termString);
  if (termError) {
    errors.counterTermMonths = [termError];
  }

  const errorList = Object.values(errors).flat();

  return {
    isValid: errorList.length === 0,
    errors: errors as Record<string, string[]>,
    firstError: errorList[0],
  };
};
